// extracted by mini-css-extract-plugin
export default {"dot":"dot_tJPGg"};